document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll(".upsell_metafield_product input")

  const badge = document.querySelector(".pdp-velocity-badge-block")

  function toggleBadge() {
    if (!badge) return

    const checkedInput = document.querySelector(
      ".upsell_metafield_product input:checked",
    )

    if (checkedInput) {
      if (checkedInput.closest(".select_metafield_product")) {
        badge.style.display = "none"
      } else {
        badge.style.display = "block"
      }
    }
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", toggleBadge)
  })

  toggleBadge()
})
